import { useState } from 'react';
import { Title } from 'components/Title';

export default function NozonePage() {
	
	const [pageReady, setPageReady] = useState(true);
	return (
		<main id="NozonePage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title="nozone"   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
